import { STAGE } from '../config';

const stripBrand = (value: string) => value
	.replace(/^Opanuj\.to:\s*/, '')
	.replace(/\s*-\s*Opanuj\.to$/, '')
	.trim();

export function formatDocumentTitle(title: string, stage = STAGE): string {
	const currentStage = String(stage || STAGE).toUpperCase();
	const normalized = stripBrand(title).trim();

	if (!normalized) {
		return normalized;
	}

	if (currentStage === 'DEVELOPMENT') {
		return normalized;
	}

	if (currentStage === 'TEST') {
		return `TEST: ${normalized}`;
	}

	return normalized;
}

export function setDocumentTitle(title: string, stage = STAGE) {
	return () => {
		if (typeof document !== 'undefined') {
			document.title = formatDocumentTitle(title, stage);
		}
	};
}
